module.exports = __webpack_public_path__ + "img/directions_boat_black_24dp.ae4a901c.svg";